module.exports = __webpack_public_path__ + "static/yg-mobile-c6ba138eae73dc7bed103a713cc891b0.png";